import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  useCanViewPersonChangeHistoryBool,
  useCanViewPersonContactBool,
  useCanViewPersonGroupsBool
} from "@/hooks/useCapabilities";
import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";
import { resolveAllowedDefaultTab, sectionGroupKey } from "@/lib/defaultTab";
import { AuthorizationContext } from "@/providers/AuthorizationProvider";

export default function PersonIndexPage() {
  const location = useLocation();
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();
  const { loaded: capabilitiesLoaded } = useContext(AuthorizationContext);
  const canViewPersonContact = useCanViewPersonContactBool();
  const canViewPersonChangeHistory = useCanViewPersonChangeHistoryBool();
  const canViewPersonGroups = useCanViewPersonGroupsBool();
  const base = location.pathname.replace(/\/$/, "");
  const group = sectionGroupKey(location.pathname);
  const navigationPreferencesOn = flags["backoffice-navigation-preferences"] === true;
  const allowedTabs = [
    "overview",
    canViewPersonContact && "contact",
    canViewPersonChangeHistory && "change-requests",
    canViewPersonChangeHistory && "change-history",
    flags["backoffice-person-profile-documents"] && "documents",
    canViewPersonGroups && "groups",
    flags["m360-timeline"] && "timeline",
    "notes"
  ].filter((slug): slug is string => Boolean(slug));
  const defaultTab = navigationPreferencesOn
    ? resolveAllowedDefaultTab(group ?? "", allowedTabs, "overview")
    : "overview";

  if (!flagsLoaded) {
    return null;
  }

  if (!navigationPreferencesOn) {
    return <Navigate to={{ pathname: `${base}/overview`, search: location.search }} replace state={location.state} />;
  }

  if (!capabilitiesLoaded) {
    return null;
  }

  return (
    <Navigate to={{ pathname: `${base}/${defaultTab}`, search: location.search }} replace state={location.state} />
  );
}
